import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

export const useGuardResource = (identity, status = false) => {
  const [value, setValue] = useState(null), [error, setError] = useState(''), [busy, setBusy] = useState(false);
  const sequence = useRef(0), alive = useRef(false), request = useRef(null);
  const invalidate = useCallback(() => {
    ++sequence.current;
    request.current?.abort(); request.current = null;
    setValue(null); setError(''); setBusy(false);
  }, []);
  const call = useCallback(async (path, method = 'get', body = {}) => {
    const turn = ++sequence.current;
    request.current?.abort();
    const controller = new AbortController(); request.current = controller;
    setBusy(true); setValue(null); setError('');
    try {
      const response = await axios({ url: `${process.env.REACT_APP_BACKEND_URL}/api/bot-pilot${path}`,
        method, ...(method === 'post' ? { data: body } : {}), withCredentials: true, timeout: 30000, signal: controller.signal });
      if (!alive.current || sequence.current !== turn) return;
      if (response.data?.signing_enabled !== false || response.data?.execution_enabled !== false) throw new Error('Unsafe guard state');
      setValue(response.data);
    } catch (failure) {
      if (alive.current && sequence.current === turn && !controller.signal.aborted) {
        const unknown = path === '/positions/recover' && (!failure.response || failure.response.status >= 500);
        setError(unknown ? 'recovery_acceptance_unknown' : typeof failure.response?.data?.detail === 'string' ? failure.response.data.detail : 'error');
      }
    } finally { if (alive.current && sequence.current === turn) setBusy(false); }
  }, []);
  useEffect(() => {
    alive.current = true; ++sequence.current; setValue(null); setError(''); setBusy(false);
    if (status) call('/guard');
    return () => { alive.current = false; ++sequence.current; request.current?.abort(); };
  }, [identity, status, call]);
  return { value, error, busy, call, invalidate };
};